import BaseIncomingPayload from "./base-incoming-payload.ts";
import IncomingPayloadEvent from "../../enums/incoming-payload-event.ts";
import ParseUtils from "../../utils/parse-utils.ts";
import User from "../../models/user.ts";

export default class V1UserGuestLoggedIn extends BaseIncomingPayload {
  public readonly payload: V1UserGuestLoggedInPayload;

  constructor(payload: Record<string, unknown>) {
    super(payload, IncomingPayloadEvent.V1_USER_GUEST_LOGGED_IN);

    this.payload = new V1UserGuestLoggedInPayload(ParseUtils.parseObject(payload, "payload"));
  }
}

export class V1UserGuestLoggedInPayload {
  public readonly user: User;

  constructor(payload: Record<string, unknown>) {
    this.user = User.fromPayload(ParseUtils.parseObject(payload, "user"));
  }
}
